var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttLastInteraction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 27,
    viewBox: "0 0 84 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-472 -579)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 27,
    rx: 13.5,
    transform: "translate(472 579)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.091,1303.309a7.925,7.925,0,0,0-7.784,6.514h-4.326a3.842,3.842,0,0,0-7.158,0h-8.54a3.839,3.839,0,0,0-7.141,0H335.6a3.844,3.844,0,1,0,0,2.8h8.524a3.835,3.835,0,0,0,7.173,0h8.524a3.842,3.842,0,0,0,7.158,0h4.31a7.933,7.933,0,1,0,7.8-9.313Zm0,13.076a5.113,5.113,0,0,1-4.937-3.763,4.837,4.837,0,0,1-.193-1.368,4.661,4.661,0,0,1,.209-1.431,5.135,5.135,0,1,1,4.921,6.562Z",
    transform: "translate(156.828 -718.309)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttLastInteraction);
export default __webpack_public_path__ + "static/media/att-last-interaction.c2f835a0c02b072ba21d6919674cb1d9.svg";
export { ForwardRef as ReactComponent };